import React, { useState } from 'react';
import './MultiplicationTable.css';  // Import the CSS file for styling

const MultiplicationTable = () => {
  const [number, setNumber] = useState('');
  const [table, setTable] = useState([]);

  const generateTable = (num) => {
    const tableArray = [];
    for (let i = 1; i <= 10; i++) {
      tableArray.push(`${num} x ${i} = ${num * i}`);
    }
    setTable(tableArray);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setNumber(value);
    generateTable(parseInt(value, 10));
  };

  return (
    <div className="container">
      <h1>Multiplication Table Generator</h1>
      <input
        type="number"
        value={number}
        onChange={handleChange}
        placeholder="Enter a number"
        className="number-input"
      />
      <div className="table-container">
        <br/>
        {table.map((row, index) => (
          <p key={index} className="table-row">{row}</p>
        ))}
      </div>
    </div>
  );
};

export default MultiplicationTable;
